<div class="custom-card">
    <div class="custom-card-header">
        <h5>
            <i class="hgi hgi-stroke text-primary" *ngIf="icone" [ngClass]="icone"></i>
            {{ titulo }}
        </h5>

        <a [routerLink]="rota" *ngIf="link">
            {{ link }}
            <i class="hgi hgi-stroke hgi-arrow-right-02 text-primary"></i>
        </a>
    </div>

    <div class="custom-card-content">
        <ng-content></ng-content>
    </div>
</div>
